<template>
  <div class="coin_picker_container b-radius-12">
    <LevelAdjuster
      :min="min"
      :max="max"
      v-model="value"
      :title="$t('calculators_common.number_of_wins')"
      :description="$t('calculators_common.select_number_of_wins')"
      :step="1"
    />
    <SingleRangePicker
      :steps="steps"
      :max="max"
      v-model="value"
      :min="min"
      :step="1"
    />
  </div>
</template>
<script setup>
import SingleRangePicker from "../../commonpickers/SingleRangePicker.vue";
import LevelAdjuster from "./LevelAdjuster.vue";
const value = ref(1);
const checkoutStore = useCheckoutStore();

const props = defineProps({
  title: {
    default: "",
  },
  description: {
    default: "",
  },
  min: {
    default: 1,
  },
  max: {
    default: 10,
  },
  modelValue: {
    default: null,
  },
  defaulValue: {
    default: 1,
  },
  steps: {
    default: [
      {
        title: "1",
      },
      // {
      //   title: "3",
      // },
      {
        title: "5",
      },
      // {
      //   title: "7",
      // },
      {
        title: "10",
      },
    ],
  },
});

watch(value, (newVal) => {
  checkoutStore.setDetails({
    ...checkoutStore.getDetails,
    numberOfWins: newVal,
  });
});
</script>

<style lang="scss">
.coin_picker_container {
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 24px;
  padding: 12px;
  border: 1px solid var(--stroke-dark);
}
</style>
